import dynamic from 'next/dynamic'

export const CrossSellDialogDynamic = dynamic(async () =>
  import('./CrossSellDialog').then((mod) => mod.CrossSellDialog),
)
